import { Lightning as lng } from '@lightningjs/sdk';
import { ScrollList } from '../../components/shared/ScrollList';

export class DetailActionRow extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      clipping: true,
      // shader: {
      //   //TODO improve fadeout
      //   type: Lightning.shaders.FadeOut,
      //   right: 30,
      // },
      // rtt: true,
      List: {
        w: w => w,
        h: h => h,
        type: ScrollList,
        peekNext: true,
        direction: 'row',
      },
    };
  }

  _init() {
    // for (let i = 0; i < 15; i++) {
    //   this.tag('List').items.childList.a({
    //     flexItem: { marginLeft: 15 },
    //     type: ActionButton,
    //     label: 'KIJK NU',
    //   });
    // }
  }

  setButtons(data, backend, modalOwner = undefined) {
    if (!data.buttons) return;
    this.tag('List').items.childList.clear();
    data.buttons.forEach(buttonDef => {
      this.tag('List').items.childList.a({
        flexItem: { marginLeft: 15 },
        backend,
        ...buttonDef,
        modalOwner,
      });
    });
  }

  _getFocused() {
    return this.tag('List');
  }
}
